import React from "react";
import FooterContact from "./FooterContact";
import FooterCourses from "./FooterCourses";
import FooterNewsletter from "./FooterNewsletter";
import FooterBottom from "./FooterBottom";

function Footer() {
  return (
    <div className="container-fluid bg-dark text-white py-5 px-sm-3 px-lg-5" style={{ marginTop: "90px" }}>
      <div className="row pt-5">
        <div className="col-lg-7 col-md-12">
          <div className="row">
            <FooterContact />
            <FooterCourses />
          </div>
        </div>
        <FooterNewsletter />
      </div>
      <FooterBottom />
    </div>
  );
}

export default Footer;